import { CrudStatus, StatusOverlay } from 'forms-crud';
import { ButtonListSelectField } from 'forms-editable';
import React, { useMemo } from 'react';
import { PopupData } from '../types';
import PwsPopupContent from './PwsPopupContent';
import PwsPopupPreviewButton from './PwsPopupPreviewButton';
import '../../styles/pws-popup-content.scss';
import '../../styles/pws-popup-editor.scss';
import { Col } from 'forms';
import t from 'rcm-i18n';

interface Props {
    onSelectPopup: (newPopupId: string) => void;
    currentPopupId: string;
    popupOptions: PopupData[];
    status: CrudStatus;
}

const PwsPopupEditor = ({
    onSelectPopup,
    currentPopupId,
    popupOptions,
    status,
}: Props) => {

    const options = useMemo(() => [
        {
            label: <Col xs={12} sm={9}>
                <div className="pws-popup-content pws-popup-content-disable">
                    {t('Default: Display no offer to visitors on my personal website pages.')}
                </div>
            </Col>,
            value: null,
        },
        ...popupOptions.map((popup) => ({
            label: <Col xs={12} sm={9}>
                <PwsPopupContent popup={popup} onLinkButtonClick={() => { }} />
                <PwsPopupPreviewButton popup={popup} />
            </Col>,
            value: popup.popupId,
        })),
    ], [popupOptions]);

    return <>
        <ButtonListSelectField
            innerClassName="pws-popup-editor"
            disabled={status === 'saving'}
            options={options}
            onValueChange={onSelectPopup}
            value={currentPopupId}
        />
        <StatusOverlay status={status} />
    </>;
};

export default PwsPopupEditor;
